"use client"

import { createContext, useContext, type ReactNode } from "react"

import { controlFillClass, type SurfaceKind } from "@/components/ui/surface-kind"

export type { SurfaceKind }
export { controlFillClass, surfaceDomProps } from "@/components/ui/surface-kind"

const SurfaceContext = createContext<SurfaceKind>("page")

/**
 * Tell descendants which well they sit on. Raised surfaces (card, dialog,
 * sheet, popover) set this so outline/secondary buttons inset instead of
 * painting the same `--card` as their parent.
 *
 * Server Components must import `surfaceDomProps` from `surface-kind`, not here.
 */
export function Surface({
  surface = "raised",
  children,
}: {
  surface?: SurfaceKind
  children: ReactNode
}) {
  return <SurfaceContext.Provider value={surface}>{children}</SurfaceContext.Provider>
}

export function useSurface(): SurfaceKind {
  return useContext(SurfaceContext)
}

/** Field / copy-well fill. Same pairing as outline buttons: lift on the page, inset on a card. */
export function useFieldFillClass(): ReturnType<typeof controlFillClass> {
  return controlFillClass(useSurface())
}
